import
    React
    , {
          useRef
        , useState
        , useCallback
        , useEffect
    } from "react";

import {
      useNavigate
    , useLocation
    //, useParams
    , Link
} from 'react-router-dom';

import {
      useDispatch
    , useSelector
} from 'react-redux';

//import { persistStore }                 from 'redux-persist';
//import store                            from "./redux/store";
import { referralCodeUpdate }           from "../../redux/keySlice";

import {
    details
    , increment
    //, setEuroValue
} from '../../redux/counterSlice';

import { MetaKeep } from 'metakeep';

import {
    axiosInstance
    //, axiosInstanceBlockChain
} from "../../utils/API";

import styles from "../../styles/app.sass";

//import ModalDialogWrapper from "../../../screens/ModalDialogWrapper";
import Login from "../Login";

//import ResetPassword                    from "../../../components/ResetPassword";
//import TermsAndConditions               from "../../../screens/TermsAndConditions"
//import PrivacyPolicy                    from "../../../screens/PrivacyPolicy"
//import ShippingPolicy                   from "../../../screens/ShippingPolicy/ShippingPolicy";
//import ReturnsPolicy                    from "../../../screens/ReturnsPolicy/ReturnsPolicy";
import Modal from "../../components/Modal";
import Icon from "../../components/Icon";

import {
    CircularProgress
    //, Drawer
    //, Divider
    //, IconButton
    //, TextField
} from "@mui/material";

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import { NAMES_CONSTANTS } from '../../constants';

import Swal from "sweetalert2";  // SweetAlert for modal dialogs

// Web3 Wallet Connect
import Web3Modal from "web3modal";
import Web3 from "web3";
//import WalletConnectProvider from "@walletconnect/web3-provider";
import { decryptData } from "../../utils/decrypt";

import {
      base_url
    , PopUpAlert
    , PopUpWarning
    , PopUpWarningThen
    , PopUpConfirmation
} from "../../controller/utils";

import LoginModal from "../../components/Header/LoginModal";

//function LoginModalDialog() {
const LoginModalDialog = props => {
    console.debug('components/ModelDialogs/LoginModalDialog(props)', props);
    
    console.debug("components/ModelDialogs/LoginModalDialog: process.env.NODE_ENV = ", process.env.NODE_ENV);

    /*
    const navigate = useNavigate(); // Error: useNavigate() may be used only in the context of a <Router> component.
    const isAgreeTermsRef = useRef(null);
    const [isAgreeTerms, setIsAgreeTerms] = useState(false);
    const userAccessToken = useRef(null);
    const emailRef = useRef(null);
    const usernameRef = useRef(null);
    const passwordRef = useRef(null);
    const repasswordRef = useRef(null);
    const firstNameRef = useRef(null);
    const lastNameRef = useRef(null);
    const registerPasswordRef = useRef(null);
    const repeatPasswordRef = useRef(null);

    const handleChangeAgreeTerms = (e) => {
        console.debug('handleChangeAgreeTerms('+e+')');

        console.debug('e.target.name = ', e.target.name);
        console.debug('e.target.value = ', e.target.value);
        console.debug('e.target.checked = ', e.target.checked);

        //setUserDetails({ ...userDetails, [e.target.name]: e.target.value })
        //setError({ ...error, [e.target.name]: '' })
        //handleUserDetailsChangeNameValue(e.target.name, e.target.value);
        //setIsAgreeTerms(e.target.value);
        //setIsAgreeTerms(e.target.checked);
        //setError({ ...error, [e.target.name]: '' })

        //registerError['agree_terms'] = 'Please Agree to the terms and conditions.';
        if (e.target.checked) {
            setRegisterError({ ...registerError, [e.target.name]: '' });
            setIsAgreeTerms(true);
        } else {
            //registerError['agree_terms'] = 'Please Agree to the terms and conditions.';
            setRegisterError({ ...registerError, [e.target.name]: 'Please agree to the terms and conditions.' });
            setIsAgreeTerms(false);
            //setRegisterError(registerError);
        }
    };
    */

    return (

        <>

            <Modal
                visible = { props.isVisibleLoginDialog }
                onClose = { props.handleCloseLoginDialog }
                //onOutsideClick = { onOutsideClickLoginDialog }
                showCloseButton = { false }
                >

                <Login
                    //visible = { props.isVisibleLoginDialog }
                    isVisibleLoginDialog = { props.isVisibleLoginDialog }
                    //onClose = { props.handleCloseLoginDialog }
                    handleCloseLoginDialog = { props.handleCloseLoginDialog }
                    //onOutsideClick = { onOutsideClickLoginDialog }
                    showCloseButton = { true }
                    isModal = { true }
                    keyDownUsername = { props.keyDownUsername }
                    usernameRef = { props.usernameRef }
                    passwordRef = { props.passwordRef }
                    keyDownPassword = { props.keyDownPassword }
                    handleLogin = { props.handleLogin }
                    handleLogin2 = { props.handleLogin2 }
                    loginError = { props.loginError }
                    clickForgotPassword = { props.clickForgotPassword }
                    clickRegister = { props.clickRegister }
                    />

            </Modal>

        </>
    );
}

export default LoginModalDialog;
